import * as React from "react";
import type { SVGProps } from "react";
const SvgNumTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <circle cx={13} cy={13} r={12.5} fill="#18A09F" />
    <path
      fill="#fff"
      d="m11.4 18.22 4.76-4.68c1.88-1.84 2.3-3.04 2.3-4.38 0-2.34-1.8-3.78-4.64-3.78-2.14 0-3.88.72-4.96 2l1.02.88C10.8 7.2 12.06 6.7 13.7 6.7c2.14 0 3.28 1 3.28 2.62 0 .96-.3 1.9-1.88 3.46l-5.82 5.7v1.02h9.82v-1.28z"
    />
  </svg>
);
export default SvgNumTwo;
